<div class="guarantee-documents-data-container">
	<div class="guarantee-documents-header">
		<copo-back-button></copo-back-button>
		<span translate>guarantee.documents</span>
	</div>
	<div class="block guarantee-documents-container">
		<div class="guarantee-documents-title">
			<span translate>guarantee.documents.title</span>
		</div>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="guaranteeDocuments.length > 0; else nodocuments">
				<div *ngFor="let guaranteeDocument of getSortedGuaranteeDocumentList(guaranteeDocuments)" class="guarantee-documents-item">
					<div class="guarantee-documents-item-title">
						<span>{{ getDocumentTitle(guaranteeDocument.files) }}</span>
					</div>
					<a *ngFor="let file of getSortedGuaranteeDocumentFileList(guaranteeDocument.files)" class="guarantee-documents-item-file-link settings-text-underlined"
						[href]="getURL(file, guaranteeDocument.id) | copoSafeUrl" target="_blank" [type]="file.type">
						{{ getLang(file.lang) }}
					</a>
				</div>
			</ng-container>
			<ng-template #nodocuments><span class="no-docs-message" translate>no.guarantee.documents</span></ng-template>
		</ng-container>
	</div>
</div>

